import EventEmitter from "base/EventEmitter";

class Message extends EventEmitter {

    constructor(message, title = "", type = Message.ERROR, settings = {}) {
        super();

        this.settings = $.extend(true, {}, Message.DEFAULT_SETTINGS, settings);
        this.message = message;
        this.title = title;
        this.type = type;

        this.buildElement();

        this.show();

        if (this.settings.autoHide) {
            this.timeout = setTimeout(() => this.hide(), 5000);
        }
    }

    show() {
        if (this.emit("show")) {
            $(".js-admin-message-holder").append(this.$element);
        }
    }

    hide() {
        if (this.emit("hide")) {
            clearTimeout(this.timeout);
            this.$element.remove();
        }
    }

    stopHiding() {
        clearTimeout(this.timeout);
    }

    buildElement() {
        this.$element = (
            eotwJSXFactory('div', {class: "admin-message " + Message.types[this.type].class + " " + (this.settings.inline ? "admin-message--inline" : "")}, [
                eotwJSXFactory('span', {class: "admin-message__icon"}, [
                    eotwJSXFactory('span', {class: "admin-message__icon-svg"}).html("<svg><use xlink:href='" + window.CONFIG.adminBuildUrl + "base/icons.svg#" + Message.types[this.type].svg + "'></use></svg>")
                ]),
                eotwJSXFactory('div', {class: "admin-message__text"}, [
                    eotwJSXFactory('div', {class: "admin-message__title"}, [this.title]),
                    eotwJSXFactory('div', {class: "admin-message__body", unsafeHtml: this.message})
                ]),
                this.settings.showClose ? eotwJSXFactory('button', {class: "admin-btn admin-btn--close js-admin-message-close"}, [
                    eotwJSXFactory('span', {class: "admin-btn__icon"}).html("<svg><use xlink:href='" + window.CONFIG.adminBuildUrl + "base/icons.svg#close'></use></svg>")
                ]) : undefined
            ])
        );
        if (!this.settings.inline) {
            this.$element.find(".js-admin-message-close").on("click", () => this.hide());
        }
    }

    toJson() {
        return {
            title: this.title,
            message: this.message,
            type: this.type,
        };
    }

    static init() {
        if (Message.inited) return;
        Message.inited = true;

        $("body").append($("<div>").addClass("admin-message-holder js-admin-message-holder"));

        Message.check_scheduled();
    }

    /**
     * @param {Message} message
     */
    static schedule(message) {
        message.hide();
        let currentSchedule = this.get_scheduled();

        currentSchedule.push(message.toJson());

        localStorage.setItem(Message.SCHEDULED_MESSAGE_KEY, JSON.stringify(currentSchedule));
    }

    static get_scheduled() {
        let currentScheduleJson = localStorage.getItem(Message.SCHEDULED_MESSAGE_KEY);

        if (currentScheduleJson === null) {
            return [];
        }
        try {
            return JSON.parse(currentScheduleJson);
        } catch (e) {
            console.error("Couldn't parse scheduled messages", e);
        }
        return [];
    }

    static check_scheduled() {
        let scheduled = this.get_scheduled();

        scheduled.forEach((item) => {
            new Message(item.message, item.title, item.type);
        });
        localStorage.removeItem(Message.SCHEDULED_MESSAGE_KEY);
    }

    static get_inline_message(errorMessage, title = "", type = Message.ERROR) {
        let message = new Message(errorMessage, title, type, {
            inline: true,
            autoHide: false,
            showClose: false,
        });

        return message.$element;
    }
}

Message.ERROR = 1;
Message.NOTICE = 2;
Message.WARNING = 3;
Message.SUCCESS = 4;

Message.SCHEDULED_MESSAGE_KEY = "adminScheduledMessages";

Message.types = {
    [Message.ERROR]: {
        "class": "admin-message--error",
        "svg": "error",
    },
    [Message.NOTICE]: {
        "class": "admin-message--notice",
        "svg": "notice",
    },
    [Message.WARNING]: {
        "class": "admin-message--warning",
        "svg": "notice",
    },
    [Message.SUCCESS]: {
        "class": "admin-message--success",
        "svg": "success",
    },
};

Message.DEFAULT_SETTINGS = {
    showClose: true,
    autoHide: true,
    inline: false,
};

$(Message.init);

export default Message;
